<template>
  <CommonLayout header="floristHeader" footer="floristFooter" ref="commonRef">
    <MeetingLayout :type="consts.meetingType.florist">
      <BOverlay :show="overlayShow" rounded="sm">
        <div class="base-color overflow-auto mh-550 shadow position-relative">
          <form method="post" action="#" class="form-horizontal" @submit.prevent>
            <div class="col-sm-12 p-5 mt-3">
              <span class="text-break" v-if="mailAddressInMsg && !brideMailAddressInMsg">
                ご入力いただいたメールアドレス（<span id="mailAddressInMsg">{{ mailAddressInMsg }}</span>）にメールを
                送信いたしました。メールが届いているかご確認をお願いいたします。
                メールアドレスを変更する場合は以下のボタンからメールアドレスの変更をお願いいたします。
              </span>

              <span class="text-break" v-else-if="!mailAddressInMsg && brideMailAddressInMsg">
                ご入力いただいたメールアドレス（<span id="brideMailAddressInMsg">{{ brideMailAddressInMsg }}</span>）にメールを
                送信いたしました。メールが届いているかご確認をお願いいたします。
                メールアドレスを変更する場合は以下のボタンからメールアドレスの変更をお願いいたします。
              </span>

              <span class="text-break" v-else-if="mailAddressInMsg && brideMailAddressInMsg">
                ご入力いただいたメールアドレス（<span id="mailAddressInMsg">{{ mailAddressInMsg }}</span>,
                <span id="brideMailAddressInMsg">{{ brideMailAddressInMsg }}</span>）にメールを
                送信いたしました。メールが届いているかご確認をお願いいたします。
                メールアドレスを変更する場合は以下のボタンからメールアドレスの変更をお願いいたします。
              </span>
            </div>
            <div class="col-sm-12">
              <div class="w-75 mt-5-auto">
                <BButton
                  type="button"
                  variant="outline-secondary"
                  class="w-100 sub-button-color white-btn-disabled"
                  @click="showMailForm"
                  :disabled="!isOperationPossible"
                >
                  メールアドレスを変更する場合
                </BButton>
              </div>
            </div>

            <transition name="fade">
              <div class="mail-send-form col-sm-12" v-show="isShowMailForm">
                <label for="mailAddress" class="control-label col-sm-12 mb-0">
                  メールアドレス(1){{ shinroShinpu1 !== 'shinro' ? '(ご新婦様)' : '(ご新郎様)' }}
                </label>

                <div class="input-group">
                  <input
                    type="text"
                    id="mailAddress"
                    class="form-control input-sm send-mail-input"
                    :class="{ 'is-invalid is-invalid-custom': v$.mailAddress.$error }"
                    v-model="mailAddress"
                    @blur="onBlur('mailAddress', $event)"
                    :disabled="!isOperationPossible"
                  />
                  <div class="invalid-feedback" v-for="e of v$.mailAddress.$errors" :key="e.$uid">{{ e.$message }}</div>
                </div>

                <label for="brideMailAddress" class="control-label col-sm-12 mb-0 mt-2">
                  メールアドレス(2){{ shinroShinpu2 !== 'shinpu' ? '(ご新郎様)' : '(ご新婦様)' }}
                </label>

                <div class="input-group">
                  <input
                    type="text"
                    id="brideMailAddress"
                    class="form-control input-sm send-mail-input"
                    :class="{ 'is-invalid is-invalid-custom': v$.brideMailAddress.$error }"
                    v-model="brideMailAddress"
                    @blur="onBlur('brideMailAddress', $event)"
                    :disabled="!isOperationPossible"
                  />
                  <div class="invalid-feedback"  v-for="e of v$.brideMailAddress.$errors" :key="e.$uid">{{ e.$message }}</div>
                </div>

                <div class="input-group-btn text-end">
                  <BButton
                    type="button"
                    class="sub-button-color ps-4 pe-4 white-btn-disabled mt-3"
                    @click="sendMail"
                    :disabled="!isOperationPossible"
                  >
                    送信
                  </BButton>
                </div>
              </div>
            </transition>

            <div class="mb-2 me-5 text-end position-absolute bottom-local">
              <!--
              <BButton variant="outline-secondary" class="w-25 sub-button-color" @click="backPage" id="back">
                戻る
              </BButton>
              -->
              <BButton
                type="button"
                variant="primary"
                class="w-25 ms-3 main-button-color blue-btn-disabled"
                @click="nextPage"
                id="next"
                :disabled="!isOperationPossible"
              >
                次へ
              </BButton>
            </div>
          </form>
        </div>
      </BOverlay>
    </MeetingLayout>

    <CommonModal ref="commonModal" />
  </CommonLayout>
</template>

<script>
import CommonLayout from '@/layout/CommonLayout'
import CommonModal from '@/components/CommonModal'
import MeetingLayout from '@/layout/MeetingLayout'
import SignalingModel from '@/models/SignalingModel'
import CommonLogModel from '@/models/CommonLogModel'
import CustomerUpdateModel from '@/models/CustomerUpdateModel'
import fstore from '@/store/florist-store'
import useVuelidate from '@vuelidate/core'
import { email, helpers, requiredIf } from '@vuelidate/validators'

export default {
  name: 'FloristMeetingSendMail',
  components: { CommonLayout, CommonModal, MeetingLayout },

  data () {
    return {
      v$: useVuelidate(),
      isShowMailForm: false,
      overlayShow: false,
      mailAddress: '',
      brideMailAddress: '',
      mailAddressInMsg: '',
      brideMailAddressInMsg: '',
      shinroShinpu1: '',
      shinroShinpu2: ''
    }
  },

  computed: {
    getSignalingData () {
      return fstore.getters.signalingReceiveData
    },

    // ★ローカル複製をやめ、常に store を参照
    isOperationPossible () {
      return !!fstore.getters.isOperationPossible
    }
  },

  watch: {
    getSignalingData (newData, oldData) {
      try {
        console.log('=== getSignalingData 開始 ===')
        console.log('newData ↓', newData)
        console.log('oldData ↓', oldData)

        newData.user = 'florist'
        newData.timestampMs = Date.now()

        CommonLogModel.apiSetStore(this.refs.commonModal, newData, () => {})

        if (newData.current_path && oldData) {
          const synchPass = newData.current_path.replace('customer', 'florist')
          if (synchPass !== this.$route.path) {
            return this.$router.push(synchPass)
          }
        }

        // 操作不可側（同期受け側）だけリモートイベント処理
        if (!fstore.getters.isOperationPossible) {
          if (newData.event === 'click' && newData.id === 'sendMail') {
            this.signalSendMail()
          }

          if (newData.event === 'input') {
            for (let i = 0; i < newData.data.length; i++) {
              if (newData.data[i] && newData.data[i].id) {
                const id = newData.data[i].id
                const elm = document.getElementById(id)

                if (id === 'isShowMailForm') {
                  this.isShowMailForm = newData.data[i].value
                } else if (elm) {
                  elm.value = newData.data[i].value
                  elm.dispatchEvent(new Event('input'))
                  elm.dispatchEvent(new Event('change'))
                }
              }
            }
          }
        }

        if (newData.event === 'text') {
          const elm = document.getElementById(newData.id)
          if (elm) elm.textContent = newData.data
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$refs.commonModal, { timestampMs: Date.now(), error: err }, () => {})
      }
    }
  },

  validations () {
    const msg = this.consts?.validationMsg?.meetingInput || {}
    const halfWidth = helpers.regex(/^[" -~]*$/)

    return {
      mailAddress: {
        required: helpers.withMessage(
          msg?.mailAddress?.required || 'メールアドレスを入力してください',
          requiredIf(() => !this.brideMailAddress?.trim())
        ),
        email: helpers.withMessage(msg?.mailAddress?.email || '有効なメールアドレスを入力してください', email),
        halfWidth: helpers.withMessage(msg?.mailAddress?.halfWidth || '半角で入力してください', halfWidth)
      },
      brideMailAddress: {
        required: helpers.withMessage(
          msg?.brideMailAddress?.required || 'メールアドレスを入力してください',
          requiredIf(() => !this.mailAddress?.trim())
        ),
        email: helpers.withMessage(msg?.brideMailAddress?.email || '有効なメールアドレスを入力してください', email),
        halfWidth: helpers.withMessage(msg?.brideMailAddress?.halfWidth || '半角で入力してください', halfWidth)
      }
    }
  },
  methods: {
    showMailForm (e) {
      try {
        console.log('showMailForm clicked', e)
        console.log('before', this.isShowMailForm)
        this.isShowMailForm = !this.isShowMailForm
        console.log('after', this.isShowMailForm)
        this.sendSignalingInputData()
      } catch (err) {
        CommonLogModel.apiSetStore(this.$refs.commonModal, { timestampMs: Date.now(), error: err }, () => {})
      }
    },

    sendSignalingInputData (e) {
      try {
        const inputs = document.querySelectorAll('.send-mail-input')
        let sendData = []

        for (let i = 0; i < inputs.length; i++) {
          if (typeof e !== 'undefined' && inputs[i].id === e.target.id) {
            sendData[i] = { target: e.target.id, id: inputs[i].id, value: inputs[i].value }
          } else {
            sendData[i] = { id: inputs[i].id, value: inputs[i].value }
          }
        }

        sendData.push({ id: 'isShowMailForm', value: this.isShowMailForm })
        sendData = sendData.filter(data => data.id !== '')

        SignalingModel.sendInputEvent(this, sendData)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$refs.commonModal, { timestampMs: Date.now(), error: err }, () => {})
      }
    },

    nextPage () {
      try {
        const targetPath = '/florist/meeting/hearing'
        SignalingModel.sendClickEvent('next', this, { target_path: targetPath.replace('florist', 'customer') })
        this.$router.push(targetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$refs.commonModal, { timestampMs: Date.now(), error: err }, () => {})
      }
    },
    backPage () {
      try {
        const targetPath = '/florist/meeting/confirm'
        SignalingModel.sendClickEvent('back', this, { target_path: targetPath.replace('florist', 'customer') })
        this.$router.push(targetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$refs.commonModal, { timestampMs: Date.now(), error: err }, () => {})
      }
    },
    onBlur (key, e) {
      this.v$?.[key]?.$touch?.()
      this.sendSignalingInputData(e)
    },
    async sendMail () {
      try {
        const cookieProjectNumberCheckResult = await this.$refs.commonRef.cookieProjectNumberCheck()
        if (!cookieProjectNumberCheckResult) {
          this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.otherCookieProjectNumber)
          return
        }
        if (this.isOperationPossible) {
          const isValid = await this.v$.$validate()

          SignalingModel.sendClickEvent('sendMail', this)

          if (!isValid) return false
          this.mailAddress = this.mailAddress.trim()
          this.brideMailAddress = this.brideMailAddress.trim()

          this.overlayShow = true
          const params = {
            mailAddress: this.mailAddress,
            brideMailAddress: this.brideMailAddress
          }
          await CustomerUpdateModel.apiSetStore(this.$refs.commonModal, params, () => {
            this.overlayShow = false
          })
          this.mailAddressInMsg = this.mailAddress
          this.brideMailAddressInMsg = this.brideMailAddress
          this.$refs.commonModal.msgBoxOk('メールを送信しました')
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$refs.commonModal, { timestampMs: Date.now(), error: err }, () => {})
        return false
      }
    },
    async signalSendMail () {
      try {
        if (!this.isOperationPossible) {
          const isValid = await this.v$.$validate()
          if (isValid) return false
          this.mailAddress = this.mailAddress.trim()
          this.brideMailAddress = this.brideMailAddress.trim()

          this.mailAddressInMsg = this.mailAddress
          this.brideMailAddressInMsg = this.brideMailAddress
          this.$refs.commonModal.msgBoxOk('メールを送信しました')
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$refs.commonModal, { timestampMs: Date.now(), error: err }, () => {})
      }
    },
    async loadValidate (e) {
      if (!e?.target?.id) return
      this.v$?.[e.target.id]?.$touch?.()
    }
  },
  created () {
    try {
      this.shinroShinpu1 = fstore.getters.shinroShinpu1
      this.shinroShinpu2 = fstore.getters.shinroShinpu2
      if (fstore.getters.mailAddress) {
        this.mailAddressInMsg = fstore.getters.mailAddress.trim()
        this.mailAddress = fstore.getters.mailAddress.trim()
      }
      if (fstore.getters.brideMailAddress) {
        this.brideMailAddressInMsg = fstore.getters.brideMailAddress.trim()
        this.brideMailAddress = fstore.getters.brideMailAddress.trim()
      }
      if (fstore.getters.shinroShinpu1 === 'shinpu' && fstore.getters.shinroShinpu2 === 'shinro') {
        ;[this.mailAddressInMsg, this.brideMailAddressInMsg, this.mailAddress, this.brideMailAddress] =
          [this.brideMailAddressInMsg, this.mailAddressInMsg, this.brideMailAddress, this.mailAddress]
        this.shinroShinpu1 = 'shinro'
        this.shinroShinpu2 = 'shinpu'
      }
      // ★ここは store のみ更新（ローカルは持たない）
      fstore.commit('setIsOperationPossible', true)

      console.log('[SendMail created] store=', fstore.getters.isOperationPossible)
    } catch (err) {
      CommonLogModel.apiSetStore(this.$refs.commonModal, { timestampMs: Date.now(), error: err }, () => {})
    }
  }
}
</script>

<style scoped type="text/css">
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
.form-control:read-only {
  background-color: #fff;
}

.blue-btn-disabled:disabled {
  background-color: rgb(0, 123, 255);
  color: #fff;
  opacity: 1;
}
.white-btn-disabled:disabled {
  color: rgb(0, 123, 255);
  border-color: rgb(0, 123, 255);
  background-color: #fff;
  opacity: 1;
}
.form-control:disabled {
  background-color: #fff;
}
input[type=radio] {
  transform: scale(2);
}
.bottom-local {
  right: 0;
  left: 0;
  bottom: 0;
}
</style>
